(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockAngebotFortsetzen', {
            bindings: {
                angebotVm: '<abafAngebotVm',
                toggleOpen: '&abafToggleOpen',
                isOpen: '<abafIsOpen',
                onSpeichern: '&abafOnSpeichern',
                options: '<abafOptions'
            },
            templateUrl: 'bloecke/angebotfortsetzen/blockAngebotFortsetzen.html',
            controller: BlockAngebotFortsetzenController,
            controllerAs: 'blockAngebotFortsetzenVm'
        });

    BlockAngebotFortsetzenController.$inject = [
        '$analytics',
        '$element',
        '$window',
        '$timeout',
        'lodash',
        'AppConfig',
        'BasisAngebotService',
        'FormatUtilsService',
        'MiscUtilsService',
        'AngebotUtilsService'
    ];
    function BlockAngebotFortsetzenController($analytics, $element, $window, $timeout, _, AppConfig, BasisAngebotService, FormatUtilsService, MiscUtilsService, AngebotUtilsService) {
        var vm = this,
            angebot,
            angebotModel,
            origIsBlockOpen;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.$doCheck = doCheck;

        vm.copyUrl = copyUrl;
        vm.speichereAngebot = speichereAngebot;
        vm.isBlockUngespeicherteAenderungenErlaubt = isBlockUngespeicherteAenderungenErlaubt;
        vm.onOpen = onOpen;
        vm.onClose = onClose;

        function activate() {
            vm.options = vm.options || {};
            vm.options.headerTitle = vm.options.headerTitle || 'Später fortsetzen?';
            angebotModel = _.get(vm.angebotVm, 'angebotModel') || {};
            angebot = angebotModel.angebot || {};

            vm.urlAngebotFortsetzen = AngebotUtilsService.getFortsetzenLink(angebotModel.angebot);
            vm.isBlockOpen = vm.isOpen;
            vm.isAppModus = MiscUtilsService.isAppModus();
        }

        function onInit() {
            var tmpEl = angular.element('<input type="text" />')[0];
            vm.isBlockOpen = origIsBlockOpen = false;
            vm.speichereAngebotInProgress = false;

            vm.isCopyUrlEnabled = (
                angular.isFunction(document.execCommand) &&
                angular.isFunction($window.getSelection) &&
                angular.isFunction($window.getSelection().addRange) &&
                angular.isFunction($window.getSelection().removeAllRanges) &&
                angular.isFunction(tmpEl.setSelectionRange) &&
                angular.isFunction(tmpEl.select)
            );
            activate();
        }

        function onChanges() {
            activate();
        }

        function doCheck() {
            if (vm.isBlockOpen) {
                vm.hatUngespeicherteAenderungen = BasisAngebotService.hatAenderungen(angebotModel.angebot, angebotModel.angebotLetzteSpeicherung);
            } else {
                vm.hatUngespeicherteAenderungen = false;
            }

            if (origIsBlockOpen !== vm.isBlockOpen) {
                origIsBlockOpen = vm.isBlockOpen;
                vm.toggleOpen({
                    open: vm.isBlockOpen
                });

                if (vm.isBlockOpen && vm.hatUngespeicherteAenderungen && !_.size(BasisAngebotService.speichereServiceInProgress)) {
                    vm.hatUngespeicherteAenderungen = false;

                    vm.angebotVm.speichereAngebot().then(function () {
                        vm.hatUngespeicherteAenderungen = BasisAngebotService.hatAenderungen(angebotModel.angebot, angebotModel.angebotLetzteSpeicherung);
                    }).finally(function () {
                        vm.onSpeichern();
                    });
                }
            }
        }
        function copyUrl(event) {
            var urlHiddenInput = $element.find('input')[0],
                range,
                selection;

            event.preventDefault();

            if (!vm.isCopyUrlEnabled) {
                return;
            }

            range = document.createRange();
            range.selectNodeContents(urlHiddenInput);

            urlHiddenInput.contenteditable = true;
            urlHiddenInput.select();

            selection = $window.getSelection();

            try {
                selection.removeAllRanges();
                selection.addRange(range);
                urlHiddenInput.setSelectionRange(0, 999999);
            } catch (e) {
                urlHiddenInput.select();
            }

            document.execCommand('copy');

            urlHiddenInput.blur();
            event.target.focus();

            if (selection !== null) {
                selection.removeAllRanges();
            }

            vm.urlCopied = true;

            $timeout(function () {
                vm.urlCopied = false;
            }, 2000);
        }
        function speichereAngebot() {
            vm.angebotVm.speichereAngebot().then(function () {
                vm.hatUngespeicherteAenderungen = BasisAngebotService.hatAenderungen(angebotModel.angebot, angebotModel.angebotLetzteSpeicherung);
            }).finally(function () {
                vm.onSpeichern();
            });
        }
        function isBlockUngespeicherteAenderungenErlaubt() {
            return (
                vm.hatUngespeicherteAenderungen &&
                BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT') &&
                !_.size(BasisAngebotService.speichereServiceInProgress)
            );
        }

        function onOpen() {
            if (vm.accordionIsOpen !== undefined) {
                $analytics.eventTrack('accordion', {
                    trackingProvider: 'wgv',
                    target: 'angebot_fortsetzen',
                    value: 'open'
                });
            }

            vm.accordionIsOpen = true;
        }

        function onClose() {
            if (vm.accordionIsOpen !== undefined) {
                $analytics.eventTrack('accordion', {
                    trackingProvider: 'wgv',
                    target: 'angebot_fortsetzen',
                    value: 'close'
                });
            }

            vm.accordionIsOpen = false;
        }
    }

})();
